/**** mgt.ControlRegion */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'ControlRegion',
  title: 'Районы контроля',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    department: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Department',
      index: 'td_id',
      fields: ['td_name'],
      format: (elem: any) => elem['td_name'],
      autocomplete: false,
    }
  },
  fields: [
    {
      name: 'cd_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'cd_name',
      title: 'Наименование',
      type: 'text',
      required: true
    },
    {
      name: 'td_id',
      title: 'Территориальный отдел',
      type: 'number',
      required: false,
      connection: 'department'
    },
    {
      name: 'geom',
      title: 'Зона',
      type: 'polygon',
      required: true,
      disableFilter: true,
    }
  ],
  newTemplate: {
    cd_id: null,
    cd_name: '',
    td_id: null,
    geom: null
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'cd_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'cd_id',
        field: 'cd_id',
      },{
        title: 'cd_name',
        field: 'cd_name',
      },{
        title: 'td_id',
        field: 'td_id',
      },{
        title: 'geom',
        field: 'geom',
      }
    ],
    example: `1;Название;1;0103000020E61000000100000005000000010000009A743E40E478A3D4B4F54D4000000000484E3E402E1000EF35F14D40010000006E373E40B194C3CD7FF64D40000000003D4A3E4011259C167FFD4D40010000009A743E40E478A3D4B4F54D40`,
    insertOnly: true,
  }


};

export default config;